import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useComparison } from '../../provider';
import { useGrid } from '../provider';
const AnchorColumnHeader = () => {
    const { setAnchorDocId } = useComparison();
    const { anchorDoc, comparatorDocs, setModalDocument, setIsDocModalOpen } = useGrid();
    const { ref: showHideRef, isComponentVisible: isAnchorSelectOpen, setIsComponentVisible: setIsAnchorSelectOpen, } = useComponentVisible(false);
    const openModal = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setModalDocument(anchorDoc);
        setIsDocModalOpen(true);
    };
    return React.createElement("div", { className: 'header cell anchor-title', title: 'Switch Anchor Document', "data-testid": 'cell-0-1', onClick: () => setIsAnchorSelectOpen(!isAnchorSelectOpen) },
        React.createElement("span", { className: 'icon' },
            React.createElement("i", { className: 'fa-star fas' })),
        React.createElement("div", { className: 'file-name overflow-ellipsis', onClick: openModal }, anchorDoc.fileName),
        "\u00A0",
        React.createElement(Link, { "data-testid": 'anchor-document-link', to: `/document/${anchorDoc.fileId}`, target: '_blank', title: 'Open in New Tab' },
            React.createElement("i", { className: 'fas fa-external-link' })),
        isAnchorSelectOpen && (React.createElement("div", { className: 'anchor-switch-dropdown', "data-testid": 'anchor-document-switcher-dialog', ref: showHideRef }, [anchorDoc, ...comparatorDocs].map((doc, index) => {
            const isSelectedAnchorDoc = doc.fileId === anchorDoc.fileId;
            const itemClass = classnames('select-item', {
                selected: isSelectedAnchorDoc,
            });
            return (React.createElement("div", { "data-testid": `anchor-doc-switcher-doc-${index}`, key: `${doc.fileId}-anchor-select`, className: itemClass, onClick: () => setAnchorDocId(doc.fileId) },
                React.createElement("span", { className: 'icon' }, isSelectedAnchorDoc && (React.createElement("i", { className: 'fas fa-star' }))),
                React.createElement("span", { className: 'overflow-ellipsis', title: doc.fileName }, doc.fileName)));
        }))));
};
export default AnchorColumnHeader;
